module.exports = __webpack_public_path__ + "img/141366-vip-user-verified.aff6196.gif";